import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithBackground.js";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";
import { FiShield, FiSettings, FiSmile, FiMail, FiPhone, FiMapPin, FiClock } from "react-icons/fi";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;
const ContentWithPaddingXl = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24 px-4 sm:px-6 lg:px-8`;
const ContentWithVerticalPadding = tw.div`py-20 lg:py-24`;
const Content2Xl = tw.div`max-w-screen-2xl mx-auto`;

const Heading = tw.h1`font-bold text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-gray-900 leading-tight`;
const HeadingRow = tw.div`flex flex-col items-center text-center`;
const Text = tw.div`mt-8 text-base text-gray-600 max-w-3xl mx-auto`;

const Form = tw.form`mt-8 md:mt-10 max-w-xl mx-auto`;
const Input = tw.input`w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5 first:mt-0`;
const TextArea = tw.textarea`w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5 first:mt-0`;
const SubmitButton = tw.button`w-full sm:w-32 mt-6 py-3 bg-gray-900 text-gray-100 rounded-lg font-medium tracking-wide text-sm transition duration-300 transform focus:outline-none focus:shadow-outline hover:bg-gray-700 hover:shadow-lg`;

const ContactInfo = tw.div`mt-12 text-center`;
const ContactInfoItem = tw.div`mt-4`;
const ContactInfoHeading = tw.h3`text-xl font-semibold text-gray-900`;
const ContactInfoText = tw.p`mt-2 text-gray-600`;

const SupportGrid = tw.div`grid grid-cols-1 md:grid-cols-2 gap-12 mt-12`;
const SupportCard = tw.div`flex flex-col items-center bg-white rounded-lg shadow-lg p-8 text-center`;
const SupportIcon = tw.div`text-primary-500 text-4xl mb-4`;
const ContactCard = tw.div`bg-primary-100 rounded-lg shadow-lg p-8 text-center mt-8 md:mt-0`;
const FormCard = tw.div`bg-white rounded-lg shadow-lg p-8`;

export default () => {
  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>Support & Assistance</Heading>
          </HeadingRow>
          <Text>
            <p className="text-center mb-8">
              Notre équipe est à votre écoute pour toute question liée à la sécurité, la configuration ou l'expérience visiteur avec Tanga.
            </p>
          </Text>

          <SupportGrid>
            <div>
              <SupportCard>
                <SupportIcon><FiShield /></SupportIcon>
                <h2 className="text-xl font-semibold mb-2">Assistance Sécurité & Confidentialité</h2>
                <p>Notre équipe vous aide à garantir la sécurité des accès et la conformité RGPD/ARTCI de votre gestion des visiteurs.</p>
              </SupportCard>
              <SupportCard>
                <SupportIcon><FiSettings /></SupportIcon>
                <h2 className="text-xl font-semibold mb-2">Support Technique</h2>
                <p>Pour toute question sur l'utilisation de la plateforme, la configuration ou l'intégration, notre support technique est à votre écoute.</p>
              </SupportCard>
              <SupportCard>
                <SupportIcon><FiSmile /></SupportIcon>
                <h2 className="text-xl font-semibold mb-2">Aide à l'Accueil</h2>
                <p>Nous accompagnons vos équipes d'accueil pour optimiser l'expérience visiteur et la rapidité des check-ins.</p>
              </SupportCard>
              <ContactCard>
                <h2 className="text-xl font-semibold mb-4">Contactez le support Tanga</h2>
                <div className="flex flex-col items-center space-y-2">
                  <span className="flex items-center gap-2"><FiMail /> <a href="mailto:support@tangagroup.africa" className="text-primary-500 underline">support@tangagroup.africa</a></span>
                  <span className="flex items-center gap-2"><FiPhone /> +225 27 22 49 49 49</span>
                  <span className="flex items-center gap-2"><FiMapPin /> Tanga Africa, Cocody Riviera Akouedo, Abidjan, Côte d'Ivoire</span>
                  <span className="flex items-center gap-2"><FiClock /> Lun-Ven: 8h-18h, Sam: 9h-13h</span>
                </div>
              </ContactCard>
            </div>
            <FormCard>
              <h2 className="text-xl font-semibold mb-4">Envoyez-nous un message</h2>
              <Form>
                <Input type="text" placeholder="Votre nom" required />
                <Input type="email" placeholder="Votre email" required />
                <Input type="text" placeholder="Sujet" required />
                <TextArea placeholder="Votre message" rows={6} required />
                <SubmitButton type="submit">Envoyer</SubmitButton>
              </Form>
            </FormCard>
          </SupportGrid>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
}; 